import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-our-packages-index",
  templateUrl: "./our-packages-index.component.html",
  styleUrls: ["./our-packages-index.component.scss"],
})
export class OurPackagesIndexComponent implements OnInit {
  sections: any[] = [
    {
      title: "E-commerce websites",
      projects: [
        {
          imgSrc:
            "../../../assets/images/our packages/projects/Device-1@2x.png",
          link: "https://eshop.codesroots.com",
          appStoreLink: "",
          googlePlayLink: "",
          name: "eshop",
        },
        {
          imgSrc:
            "../../../assets/images/our packages/projects/Device@2x.png",
          link: "https://emart.codesroots.com",
          appStoreLink: "",
          googlePlayLink: "",
          name: "emart",
        },
        {
          imgSrc:
            "../../../assets/images/our packages/projects/Device-3@2x.png",
          link: "https://el-ezaby.codesroots.com",
          appStoreLink: "",
          googlePlayLink: "",
          name: "el-ezaby",
        },
        {
          imgSrc:
            "../../../assets/images/our packages/projects/Device-2@2x.png",
          link: "https://ximivogueegypt.codesroots.com",
          appStoreLink: "",
          googlePlayLink: "",
          name: "ximivogueegypt",
        },
      ],
    },
    {
      title: "Restaurant websites",
      projects: [
        {
          imgSrc:
            "../../../assets/images/our packages/projects/Device-5@2x.png",
          link: "https://gad.codesroots.com",
          appStoreLink: "",
          googlePlayLink: "",
          name: "gad",
        },
        {
          imgSrc:
            "../../../assets/images/our packages/projects/Device-4@2x.png",
          link: "https://abohassan.codesroots.com",
          appStoreLink: "",
          googlePlayLink: "",
          name: "abohassan",
        },
      ],
    },
  ];
  constructor() {}
  ngOnInit(): void {}
}
